<template>
  <VTextarea :type="type" :loading="loading" variant="outlined" color="primary" v-bind="$attrs" />
</template>

<script setup>
defineProps({
  type: { type: String, required: true },
  loading: { type: Boolean, default: false },
});
</script>
